import { useTranslation } from "react-i18next"

const STEP_KEYS = ["addProducts", "setupTryOn", "makeAvailable"] as const

export const MakeupSetupSteps = () => {
  const { t } = useTranslation()

  return (
    <ol
      className="mt-2 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-foreground/70"
      data-testid="makeup-setup-steps"
    >
      {STEP_KEYS.map((key, index) => (
        <li key={key} className="flex items-center gap-1.5">
          <span>{index + 1}.</span>
          <span>{t(`makeup.steps.${key}`)}</span>
        </li>
      ))}
    </ol>
  )
}
